import { configureStore } from '@reduxjs/toolkit'
import {
	createStateSyncMiddleware,
	initMessageListener,
} from 'redux-state-sync'

import { authCreators, authReducer } from './ducks/auth'
import { contentReducer } from './ducks/content'
import { modalReducer } from './ducks/modal'
import { themeReducer } from './ducks/theme'
import { notificationReducer } from './ducks/notification'
import { matriculateReducer } from './ducks/matriculate'
import { drawerReducer } from './ducks/drawer'

import {
	authRepository,
	cohortsRepository,
	companyRepository,
	creditsRepository,
	libraryRepository,
	liveClassRepository,
	mentorshipsRepository,
	mentorsRepository,
	modalsMentorshipsRepository,
	modalsRepository,
	onboardingRepository,
	profileAwariRepository,
	profileRepository,
	trailsRepository,
	typeformRepository,
	webhookRepository,
} from '@/repositories'
import { errorMiddleware } from './middlewares/error'

const reduxStateSyncConfig = {
	whitelist: [
		authCreators.authenticate.type,
		authCreators.setUser.type,
		authCreators.logout.type,
	],
}

export const store = configureStore({
	reducer: {
		auth: authReducer,
		matriculate: matriculateReducer,
		content: contentReducer,
		theme: themeReducer,
		modal: modalReducer,
		drawer: drawerReducer,
		notification: notificationReducer,
		[authRepository.reducerPath]: authRepository.reducer,
		[profileRepository.reducerPath]: profileRepository.reducer,
		[profileAwariRepository.reducerPath]: profileAwariRepository.reducer,
		[onboardingRepository.reducerPath]: onboardingRepository.reducer,
		[modalsRepository.reducerPath]: modalsRepository.reducer,
		[modalsMentorshipsRepository.reducerPath]:
			modalsMentorshipsRepository.reducer,
		[companyRepository.reducerPath]: companyRepository.reducer,
		[liveClassRepository.reducerPath]: liveClassRepository.reducer,
		[libraryRepository.reducerPath]: libraryRepository.reducer,
		[cohortsRepository.reducerPath]: cohortsRepository.reducer,
		[typeformRepository.reducerPath]: typeformRepository.reducer,
		[mentorshipsRepository.reducerPath]: mentorshipsRepository.reducer,
		[mentorsRepository.reducerPath]: mentorsRepository.reducer,
		[creditsRepository.reducerPath]: creditsRepository.reducer,
		[webhookRepository.reducerPath]: webhookRepository.reducer,
		[trailsRepository.reducerPath]: trailsRepository.reducer,
	},
	middleware: (getDefaultMiddleware: any) =>
		getDefaultMiddleware({ serializableCheck: false })
			.concat(createStateSyncMiddleware(reduxStateSyncConfig))
			.concat(
				authRepository.middleware,
				profileRepository.middleware,
				profileAwariRepository.middleware,
				onboardingRepository.middleware,
				modalsRepository.middleware,
				modalsMentorshipsRepository.middleware,
				companyRepository.middleware,
				libraryRepository.middleware,
				liveClassRepository.middleware,
				cohortsRepository.middleware,
				typeformRepository.middleware,
				mentorshipsRepository.middleware,
				mentorsRepository.middleware,
				creditsRepository.middleware,
				webhookRepository.middleware,
				trailsRepository.middleware
			)
			.concat(errorMiddleware),
})

// Inicializar o listener de mensagens para sincronização entre abas
initMessageListener(store)

export type RootState = ReturnType<typeof store.getState>
